// Easy mode already refuses to leave an invalid step, so the tour gates on the
// wizard's own validation instead of a second set of rules that could disagree
// with it. Only the wording is the tour's own.

// A field error reads as a complaint about a field nobody has touched yet, so
// the hint names the next thing to do instead. The exact reason still shows
// against the field itself once it has been touched.
const INTAKE_FIELD_HINTS = {
   caseType: "Pick the case type to carry on.",
   stateOfIncident: "Pick the state the incident occurred in to carry on.",
   dateOfIncident: "Pick the date of the incident to carry on.",
   plaintiffCount: "Set how many plaintiffs are on the case to carry on.",
   defendantCount: "Set how many defendants are on the case to carry on.",
};

// Step 1 reports a field-keyed errors object, the later steps a single error
// that already reads as an instruction
const getStepMessage = (result) => {
   if (result?.error) {
      return result.error;
   }

   const [[field, fieldMessage] = []] = Object.entries(result?.errors ?? {});

   return INTAKE_FIELD_HINTS[field] ?? fieldMessage ?? null;
};

// canSkip is off throughout: the wizard blocks these steps itself, so a skip
// would move the tooltip on and leave the user against the same wall. Exiting
// the tour is still there for anyone who does not have the material to hand.
export const buildStepRequirement = ({ step, fallbackHint }) => ({
   isSatisfied: ({ stepValidation }) => Boolean(stepValidation?.[step]?.isValid),
   hint: ({ stepValidation }) => getStepMessage(stepValidation?.[step]) ?? fallbackHint,
   canSkip: false,
});

export default buildStepRequirement;
